const translations = {
  es: {
    nav: {
      about: "Estudio", services: "Servicios", projects: "Trabajo",
      pricing: "Precios", faq: "FAQ", contact: "Hablemos", langToggle: "EN",
    },
    hero: {
      tag: "Estudio · Tomás Pernalete · Diseño & desarrollo",
      title: "Sitios que se sienten <em>hechos a mano</em>, no en molde.",
      description: "Estudio independiente. Sitios a medida, rápidos y con carácter — no plantillas.",
      scrollHint: "Desliza",
    },
    about: {
      title: "Soy Tomás Pernalete. Obsesionado con el detalle.",
      lead: "Trabajo como estudio independiente. Hablas <em>directamente</em> con quien diseña y construye tu sitio.",
      body: [
        "Sin intermediarios, sin plantillas, sin las mismas tres soluciones de siempre. Cada proyecto es una pieza a medida.",
        "Creo que una buena web es partes iguales estética y estrategia — bonita porque funciona, no a pesar de ello.",
      ],
      stats: [
        { num: "0", suffix: "", label: "Plantillas usadas" },
        { num: "100", suffix: "%", label: "Código a medida" },
        { num: "<24", suffix: "h", label: "Tiempo de respuesta" },
      ],
    },
    services: {
      title: "Todo lo que necesita <em>tu negocio,</em> hecho a mano.",
      subtitle: "Yo me encargo de todo: el diseño, la página y que funcione. Tú solo me cuentas cómo es tu negocio.",
      items: [
        { num: "01", title: "Tu página hecha a mano", desc: "Diseño tu página desde cero, pensada para tu negocio. Nada de plantillas que todos usan.", tags: ["Diseño único", "Tu estilo", "Fotos", "Colores"] },
        { num: "02", title: "Rápida y fácil", desc: "Rápida de verdad y perfecta en el celular, la tablet o la computadora.", tags: ["Celular", "Rápida", "Fácil de usar"] },
        { num: "03", title: "Que te encuentren en Google", desc: "SEO técnico y contenido pensado para que aparezcas cuando alguien busca lo que vendes.", tags: ["Google", "Búsquedas"] },
        { num: "04", title: "Páginas que traen clientes", desc: "Pensada para que la gente te llame, te escriba por WhatsApp o pase por tu local.", tags: ["WhatsApp", "Llamadas", "Ubicación", "Reservas"] },
        { num: "05", title: "Bilingüe (ES / EN)", desc: "Tu página en español e inglés, escrita a mano en los dos — nada de traducción automática.", tags: ["ES", "EN"] },
      ],
    },
    tools: {
      title: "No solo tu página. <em>Herramientas</em> que hacen funcionar tu negocio.",
      subtitle: "Si hay algo que haces a mano cada semana, casi siempre se puede automatizar. Construyo las piezas que te devuelven esas horas.",
      featured: {
        badge: "Lo que nadie más te ofrece",
        title: "Un asistente que atiende tu web solo",
        desc: "Responde las dudas de quien entra, toma sus datos y le agenda la cita en tu calendario. A las tres de la mañana, un domingo, o mientras estás atendiendo a otro cliente. Y en cuanto quieres tomar tú la conversación, se calla.",
        points: [
          "Contesta en segundos, todos los días del año",
          "Agenda solo en los huecos libres de tu calendario",
          "Te avisa por correo de cada cliente nuevo",
          "Habla como tu negocio, no como un robot",
        ],
        note: "Es el mismo que está funcionando en esta página, abajo a la derecha. Escríbele y pruébalo.",
      },
      items: [
        { title: "Menú o catálogo digital", desc: "Tus productos con fotos y precios, y el pedido te llega directo por WhatsApp." },
        { title: "Reservas en línea", desc: "Tus clientes eligen día y hora solos. Sin llamadas cruzadas ni citas repetidas." },
        { title: "Un panel para tu negocio", desc: "Un lugar donde ves tus clientes, tus pedidos y cómo viene la semana." },
        { title: "Formularios que avisan", desc: "Cada consulta te llega al correo y queda guardada. No se pierde nada en el camino." },
        { title: "Cobros y facturas", desc: "Manda la factura por correo y cobra con tarjeta o transferencia, sin perseguir a nadie." },
        { title: "Lo que tu negocio necesite", desc: "Cuéntame qué haces a mano cada semana y vemos si vale la pena construirlo." },
      ],
    },
    marquee: ["Hecho a mano", "Diseño con intención", "Código propio", "Sitios rápidos", "Trato directo", "Sin plantillas"],
    projects: {
      title: "Proyectos <em>reales,</em> negocios en vivo.",
      liveLabel: "En vivo",
      soonLabel: "Próximamente",
      carousel: { prev: "Proyecto anterior", next: "Proyecto siguiente", label: "Carrusel de proyectos", goTo: "Ir a" },
      items: [
        { id: "01", title: "Los Caminos", tag: "Programa de liderazgo · Sitio bilingüe" },
        { id: "02", title: "Monarch Hair Studio", tag: "Peluquería · Reservas online" },
        { id: "03", title: "Javier Aldama", tag: "Fotografía de bodas · Portafolio" },
        { id: "04", title: "414 Visual Studio", tag: "Interiorismo · Visualización 3D" },
        { id: "05", title: "Fast Tire Service", tag: "Servicio móvil de neumáticos · 24/7" },
        { id: "06", title: "Aleshka Rodriguez", tag: "Dula de parto y posparto · Sitio bilingüe" },
        { id: "07", title: "Únicas Nail Estudio", tag: "Manicura artesanal · Reservas online" },
        { id: "08", title: "Tu negocio podría estar aquí", tag: "Espacio disponible · Hablemos" },
      ],
      caminos: { kick: "Programa de liderazgo juvenil", heading: "Una semana en el camino que forma <em>a los líderes del mañana</em>.", cta: "Inscríbete" },
      monarch: { kick: "Hair Studio · Vancouver", heading: "Cortes con <em>carácter,</em> color con criterio.", cta: "Reservar cita" },
      jav: { kick: "Fotografía de bodas · Houston, TX", heading: "Las historias más bonitas merecen <em>recordarse para siempre</em>.", cta: "Ver historias" },
      visual414: { kick: "Interiorismo · Coro, Venezuela", heading: "Mira tu espacio <em>antes de construirlo</em>.", cta: "Ver trabajo" },
      fasttire: { kick: "Neumáticos móviles · Columbia Basin, WA", heading: "Servicio móvil que <em>llega hasta usted</em>.", cta: "Llamar ahora" },
      doula: { kick: "Dula de parto y posparto · Washington", heading: "No tienes que <em>hacerlo sola</em>.", cta: "Solicitar servicios" },
      unicas: { kick: "Manicura artesanal · Lacey, WA", heading: "El arte <em>en tus manos</em>.", cta: "Reservar turno" },
      soon: { badge: "Aceptando proyectos", big: "Tu <em>proyecto</em><br/>aquí.", hint: "Espacio reservado para tu negocio" },
    },
    pricing: {
      title: "Claros y <em>sencillos.</em> Sin sorpresas.",
      note: '¿Necesitas otra cosa? <a href="https://wa.me/15642257839?text=Hola%20Tom%C3%A1s%2C%20necesito%20algo%20distinto%20a%20los%20planes%20de%20tu%20web" target="_blank" rel="noopener noreferrer">Escríbeme</a> y lo vemos juntos.',
      ctaLabel: "Pedir presupuesto",
      priceNote: "desde · pago único",
      tiers: [
        { kin: "Sencillo", title: "Una página", desc: "Todo tu negocio en una sola página. Perfecta para empezar.", price: "$300",
          features: ["Todo en una página: quién eres, qué ofreces y cómo llegar", "Se ve bien en el celular", "Botón de WhatsApp y tu ubicación en el mapa", "Lista en 1 o 2 semanas"], best: false },
        { kin: "Completo", title: "Varias páginas", desc: "Una web con varias páginas para mostrar más de tu negocio.", price: "$500",
          features: ["Hasta 5 páginas (inicio, servicios, fotos, contacto…)", "Diseño hecho para tu negocio", "Apareces en Google", "Menú o lista de servicios con precios"], best: true, rec: "El más pedido" },
        { kin: "Todo listo", title: "Logo + página", desc: "Tu logo y tu página, todo de una vez.", price: "$1,500",
          features: ['Todo lo de "varias páginas"', "Tu logo y el diseño de tu marca", "Colores y plantillas para tus redes sociales", "Te ayudo el primer mes después de abrir"], best: false },
      ],
      guarantee: {
        label: "Sin riesgo para ti",
        items: [
          { k: "No escribes una palabra", v: "Saco los textos y las fotos de tu Instagram y tu ficha de Google. Tú solo revisas y corriges." },
          { k: "Lo ves funcionando en 7 días", v: "Un sitio real en tu navegador, no una promesa ni un boceto." },
          { k: "Si no te gusta, no pagas", v: "Sin letra chica. Se paga cuando lo apruebas, no antes." },
        ],
      },
    },
    faq: {
      title: "Lo que casi todos <em>me preguntan.</em>",
      items: [
        { q: "¿Tengo que escribir yo los textos?", a: "No. Saco el contenido de tu Instagram, tu ficha de Google y lo que ya tengas dando vueltas. Te lo muestro armado y tú corriges lo que no te represente. Ese es justo el paso donde estos proyectos se atascan durante meses, así que lo hago yo." },
        { q: "¿Y si no me gusta cómo queda?", a: "No pagas. En 7 días te muestro el sitio funcionando en tu navegador, no un boceto. Si no te convence, ahí termina y no me debes nada." },
        { q: "¿Qué es eso del asistente con IA?", a: "Un chat que se instala en tu web y atiende solo: responde dudas, toma los datos de quien escribe y le agenda la cita en tu calendario. El que está en esta página, abajo a la derecha, es exactamente ese — escríbele y lo pruebas." },
        { q: "¿Cuánto tarda un proyecto?", a: "Una landing suele estar en 1–2 semanas; un sitio completo, entre 3 y 5. El tiempo depende sobre todo de lo rápido que recibamos contenido y feedback. Te doy un calendario claro antes de empezar." },
        { q: "¿Trabajas con plantillas?", a: "No. Cada sitio se diseña y se programa desde cero para tu marca. Por eso ninguno de mis proyectos se parece a otro." },
        { q: "¿Cómo funcionan los pagos?", a: "Normalmente 50% para arrancar y 50% al entregar. En proyectos grandes lo dividimos por etapas. Sin costos ocultos: lo que acordamos es lo que pagas." },
        { q: "¿Y después de lanzar?", a: "Sigo disponible. Puedes contratar mantenimiento mensual o pedir cambios puntuales cuando los necesites. Tu sitio no se queda huérfano el día del lanzamiento." },
        { q: "¿Puedo cambiar cosas yo mismo?", a: "Sí. Si quieres, te la dejo lista para que cambies textos, precios o fotos tú mismo, sin saber nada de computación. Lo vemos al principio." },
      ],
    },
    contact: {
      badge: "Disponible para nuevos proyectos",
      title: "¿Construimos algo que <em>no se parezca</em> a nada?",
      desc: "Cuéntame tu idea. Respondo en menos de 24 horas con una primera impresión honesta y los siguientes pasos.",
      ctaEmail: "Escríbeme",
      ctaWhatsapp: "WhatsApp",
      form: {
        name: "Nombre", email: "Email", budget: "Presupuesto aproximado", description: "Cuéntame de tu proyecto",
        dateLabel: "Fecha preferida para hablar (opcional)", pickDate: "Elegir fecha",
        submit: "Enviar", sending: "Enviando…", sentLabel: "✓ Enviado",
        success: "¡Listo! Te respondo en menos de 24 horas.", error: "Algo falló. Intenta de nuevo o escríbeme directo por email.",
      },
      channels: {
        newProjects: { h: "Nuevos proyectos" },
        whatsapp: { h: "WhatsApp" },
      },
      footer: "© 2026 Pernalete Studio — Hecho a mano en la web",
    },
  },
  en: {
    nav: {
      about: "Studio", services: "Services", projects: "Work",
      pricing: "Pricing", faq: "FAQ", contact: "Let's talk", langToggle: "ES",
    },
    hero: {
      tag: "Studio · Tomás Pernalete · Design & development",
      title: "Sites that feel <em>handmade</em>, not cookie-cutter.",
      description: "Independent studio. Custom sites, fast and with character — no templates.",
      scrollHint: "Scroll",
    },
    about: {
      title: "I'm Tomás Pernalete. Obsessed with detail.",
      lead: "I work as an independent studio. You talk <em>directly</em> with whoever designs and builds your site.",
      body: [
        "No middlemen, no templates, no recycled solutions. Every project is custom-built.",
        "I believe a good website is equal parts aesthetics and strategy — pretty because it works, not despite it.",
      ],
      stats: [
        { num: "0", suffix: "", label: "Templates used" },
        { num: "100", suffix: "%", label: "Custom code" },
        { num: "<24", suffix: "h", label: "Response time" },
      ],
    },
    services: {
      title: "Everything <em>your business</em> needs, handmade.",
      subtitle: "I handle all of it: design, the page, and making it work. You just tell me about your business.",
      items: [
        { num: "01", title: "Your site, handmade", desc: "I design your page from scratch, built for your business. No templates everyone else uses.", tags: ["Unique design", "Your style", "Photos", "Colors"] },
        { num: "02", title: "Fast and easy", desc: "Seriously fast and looks perfect on phone, tablet, or computer.", tags: ["Mobile", "Fast", "Easy to use"] },
        { num: "03", title: "Found on Google", desc: "Technical SEO and content built so you show up when someone searches for what you sell.", tags: ["Google", "Searches"] },
        { num: "04", title: "Pages that bring customers", desc: "Built so people call you, message you on WhatsApp, or stop by your store.", tags: ["WhatsApp", "Calls", "Location", "Bookings"] },
        { num: "05", title: "Bilingual (ES / EN)", desc: "Your site in Spanish and English, hand-written in both — no machine translation.", tags: ["ES", "EN"] },
      ],
    },
    tools: {
      title: "Not just your site. <em>Tools</em> that keep your business running.",
      subtitle: "If there's something you do by hand every week, it can usually be automated. I build the pieces that give those hours back.",
      featured: {
        badge: "What nobody else offers",
        title: "An assistant that runs your site on its own",
        desc: "It answers questions from whoever lands on your site, takes their details, and books the meeting straight into your calendar. At three in the morning, on a Sunday, or while you're with another client. And the moment you want to take over, it steps aside.",
        points: [
          "Replies in seconds, every day of the year",
          "Books only in the open slots on your calendar",
          "Emails you about every new lead",
          "Sounds like your business, not like a robot",
        ],
        note: "It's the same one running on this page, bottom right. Write to it and try it.",
      },
      items: [
        { title: "Digital menu or catalog", desc: "Your products with photos and prices — orders land straight in your WhatsApp." },
        { title: "Online booking", desc: "Clients pick their own day and time. No phone tag, no double bookings." },
        { title: "A dashboard for your business", desc: "One place to see your clients, your orders, and how the week is going." },
        { title: "Forms that reach you", desc: "Every enquiry hits your inbox and stays on file. Nothing gets lost along the way." },
        { title: "Invoices and payments", desc: "Send the invoice by email and get paid by card or transfer, without chasing anyone." },
        { title: "Whatever your business needs", desc: "Tell me what you do by hand every week and we'll see if it's worth building." },
      ],
    },
    marquee: ["Handmade", "Design with intent", "Hand-coded", "Fast sites", "Direct contact", "No templates"],
    projects: {
      title: "Real <em>projects,</em> live businesses.",
      liveLabel: "Live",
      soonLabel: "Coming soon",
      carousel: { prev: "Previous project", next: "Next project", label: "Projects carousel", goTo: "Go to" },
      items: [
        { id: "01", title: "Los Caminos", tag: "Leadership program · Bilingual site" },
        { id: "02", title: "Monarch Hair Studio", tag: "Hair salon · Online booking" },
        { id: "03", title: "Javier Aldama", tag: "Wedding photography · Portfolio" },
        { id: "04", title: "414 Visual Studio", tag: "Interior design · 3D visualization" },
        { id: "05", title: "Fast Tire Service", tag: "Mobile tire service · 24/7" },
        { id: "06", title: "Aleshka Rodriguez", tag: "Birth & postpartum doula · Bilingual site" },
        { id: "07", title: "Únicas Nail Estudio", tag: "Handmade manicure · Online booking" },
        { id: "08", title: "Your business could be here", tag: "Spot available · Let's talk" },
      ],
      caminos: { kick: "Youth leadership program", heading: "A week on the path that shapes <em>tomorrow's leaders</em>.", cta: "Enroll" },
      monarch: { kick: "Hair Studio · Vancouver", heading: "Cuts with <em>character,</em> color with intent.", cta: "Book now" },
      jav: { kick: "Wedding photography · Houston, TX", heading: "The most beautiful stories deserve to be <em>remembered forever</em>.", cta: "View stories" },
      visual414: { kick: "Interior design · Coro, Venezuela", heading: "See your space <em>before it's built</em>.", cta: "View work" },
      fasttire: { kick: "Mobile tires · Columbia Basin, WA", heading: "Mobile tire service <em>that comes to you</em>.", cta: "Call now" },
      doula: { kick: "Birth & postpartum doula · Washington", heading: "You do not have to <em>do this alone</em>.", cta: "Request services" },
      unicas: { kick: "Handmade manicure · Lacey, WA", heading: "The art <em>in your hands</em>.", cta: "Book now" },
      soon: { badge: "Taking projects", big: "Your <em>project</em><br/>here.", hint: "Slot reserved for your business" },
    },
    pricing: {
      title: "Clear and <em>simple.</em> No surprises.",
      note: 'Need something else? <a href="https://wa.me/15642257839?text=Hi%20Tom%C3%A1s%2C%20I%20need%20something%20different%20from%20the%20plans%20on%20your%20site" target="_blank" rel="noopener noreferrer">Write me</a> and we\'ll figure it out.',
      ctaLabel: "Ask for a quote",
      priceNote: "starting at · one-time",
      tiers: [
        { kin: "Simple", title: "One page", desc: "Your whole business on a single page. Perfect to start.", price: "$300",
          features: ["Everything on one page: who you are, what you offer, how to reach you", "Looks great on phone", "WhatsApp button and your location on the map", "Ready in 1–2 weeks"], best: false },
        { kin: "Complete", title: "Multiple pages", desc: "A site with several pages to show more of your business.", price: "$500",
          features: ["Up to 5 pages (home, services, photos, contact…)", "Design built for your business", "Shows up on Google", "Menu or service list with pricing"], best: true, rec: "Most requested" },
        { kin: "All-in", title: "Logo + site", desc: "Your logo and your site, all at once.", price: "$1,500",
          features: ['Everything in "multiple pages"', "Your logo and brand design", "Colors and templates for your social media", "First-month support after launch"], best: false },
      ],
      guarantee: {
        label: "No risk on your side",
        items: [
          { k: "You don't write a word", v: "I pull the copy and photos from your Instagram and your Google listing. You just review and correct." },
          { k: "You see it working in 7 days", v: "A real site in your browser — not a promise, not a mockup." },
          { k: "If you don't like it, you don't pay", v: "No fine print. You pay when you approve it, not before." },
        ],
      },
    },
    faq: {
      title: "What almost everyone <em>asks me.</em>",
      items: [
        { q: "Do I have to write the copy?", a: "No. I pull the content from your Instagram, your Google listing, and whatever you already have lying around. I show it to you assembled and you correct anything that doesn't sound like you. That's exactly the step where these projects stall for months, so I handle it." },
        { q: "What if I don't like how it turns out?", a: "You don't pay. In 7 days I show you the site working in your browser, not a mockup. If it doesn't convince you, that's where it ends and you owe me nothing." },
        { q: "What's this AI assistant?", a: "A chat that installs on your site and handles it alone: answers questions, takes the details of whoever writes, and books the meeting into your calendar. The one on this page, bottom right, is exactly that — write to it and try it." },
        { q: "How long does a project take?", a: "A landing page usually takes 1–2 weeks; a full site, 3 to 5. It mostly depends on how fast we get content and feedback. I give you a clear timeline before starting." },
        { q: "Do you use templates?", a: "No. Every site is designed and coded from scratch for your brand. That's why none of my projects look alike." },
        { q: "How do payments work?", a: "Usually 50% to start and 50% on delivery. For bigger projects we split it by milestones. No hidden costs: what we agree on is what you pay." },
        { q: "What happens after launch?", a: "I stay available. You can hire monthly maintenance or request one-off changes whenever you need. Your site isn't orphaned on launch day." },
        { q: "Can I edit things myself?", a: "Yes. If you want, I'll set it up so you can change text, prices, or photos yourself, no coding knowledge needed. We cover this at the start." },
      ],
    },
    contact: {
      badge: "Open for new projects",
      title: "Should we build something that <em>looks like nothing</em> else?",
      desc: "Tell me your idea. I reply within 24 hours with an honest first take and the next steps.",
      ctaEmail: "Email me",
      ctaWhatsapp: "WhatsApp",
      form: {
        name: "Name", email: "Email", budget: "Approximate budget", description: "Tell me about your project",
        dateLabel: "Preferred date to talk (optional)", pickDate: "Pick a date",
        submit: "Send", sending: "Sending…", sentLabel: "✓ Sent",
        success: "Done! I'll reply within 24h.", error: "Something failed. Try again or email me directly.",
      },
      channels: {
        newProjects: { h: "New projects" },
        whatsapp: { h: "WhatsApp" },
      },
      footer: "© 2026 Pernalete Studio — Handmade on the web",
    },
  },
};

export default translations;
